import { ReactElement } from 'react';
import { Device } from 'synapse-common-device-service';
import { Typography } from '@getgo/chameleon-web-react-wrapper/register';
import styles from './TenantCellRenderer.module.scss';
import { UpdateJobItem } from '../../../windows-updates/models/update-job-item';
import Tenant from '../../../core/models/Tenant';
import { useTranslation } from 'react-i18next';

function JobTenantCellRenderer(data: UpdateJobItem, tenantDevices: Device[]): ReactElement {
  const cellTenantsArray: Tenant[] = [];
  const { t } = useTranslation();

  const noTenantOption = {
    uuid: 'items-without-tenant',
    name: t('windowsUpdatesSelector.noTenant')
  };

  if ((data.tenants ?? []).length === 0) cellTenantsArray.push(noTenantOption);
  (data.devicesNames ?? []).forEach(deviceId => {
    if (
      !(tenantDevices ?? []).find(device => device.id === deviceId) &&
      !cellTenantsArray.find(cellTenant => cellTenant.uuid === 'items-without-tenant')
    ) {
      cellTenantsArray.push(noTenantOption);
    }
    const cellTenantDevices = (tenantDevices ?? []).filter(device => device.id === deviceId);
    cellTenantDevices.forEach(device => {
      if (device.group?.tenant && !cellTenantsArray.find(cellTenant => device?.group?.tenant?.id === cellTenant.uuid)) {
        cellTenantsArray.push({
          uuid: device.group.tenant.id,
          name: device.group.tenant.name
        });
      }
    });
  });

  const fragments: ReactElement[] = cellTenantsArray.map((tenant, index) => (
    <span key={tenant.uuid}>
      {tenant.name}
      {index !== cellTenantsArray.length - 1 && ', '}
    </span>
  ));

  return (
    <Typography variant={'body-small'} className={styles.text} lineClamp={2}>
      <>{fragments}</>
    </Typography>
  );
}

export default JobTenantCellRenderer;
